export default __webpack_public_path__ + "static/index-header-img-md-2480349662195a71b19954ef15176f2b.webp";